import * as React from 'react';
import { BrowserRouter as Router, Route, Redirect, Switch } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './components/Home';
import Counter from './components/Counter';
import FetchData from './components/FetchData';

import Account from './components/Account';
import Notifications from './components/Notifications';
import Patient from './components/Patient';

import PrivateRoute from "./components/common/PrivateRoute";
import CallbackPage from "./components/CallbackPage";
import LoginPage from "./components/LoginPage";
import LogoutPage from "./components/LogoutPage";
import NotificationItem from "./components/NotificationItem";
import NotificationReply from "./components/NotificationReply";
import NotificationCompose from "./components/notification/NotificationCompose";
import PatientsTable from './components/PatientsTable'
import DocumentIndex from './components/patient/DocumentIndex'
import DirectAdmitRequest from './components/directadmit/DirectAdmitRequest'
import PracticeCoordinatorPatientsTable from './components/PracticeCoordinatorPatientsTable';
import CareCoordinatorAccount from './components/CareCoordinatorAccount';
import AdmitNotificationItem from './components/notification/AdmitNotificationItem';
import DischargeNotificationItem from './components/notification/DischargeNotificationItem';
import NotificationComposeSingle from './components/notification/NotificationComposeSingle';
import PtMedicalRecord from './components/PtMedicalRecord';

export default () => (
    <Router>
        <Switch>
            <PrivateRoute exact path="/" component={Home} />
            <Route path="/login" component={LoginPage} />
            <Route path="/callback" component={CallbackPage} />
            <PrivateRoute path='/dashboard' component={Home} />
            <PrivateRoute path='/counter' component={Counter} />
            <PrivateRoute path='/patient-list' component={PatientsTable} />
            <PrivateRoute path='/patient-list-practice' component={PracticeCoordinatorPatientsTable} />
            <PrivateRoute path='/notifications' component={Notifications} />
            <PrivateRoute path='/patient/documents' component={DocumentIndex} />
            <PrivateRoute path='/account' component={Account} />
            <PrivateRoute path='/patient/:PtId' component={Patient} />
            <Route path="/logout" component={LogoutPage} />
            <PrivateRoute path="/fetch-data/:startDateIndex?" component={FetchData} />
            <PrivateRoute path="/record/document/:ptid/:condensedName" component={PtMedicalRecord} />

            <PrivateRoute path="/notification-item/:MessageId" component={NotificationItem} />
            <PrivateRoute path="/admit-notification/:MessageId" component={AdmitNotificationItem} />
            <PrivateRoute path="/discharge-notification/:MessageId" component={DischargeNotificationItem} />
            <PrivateRoute path="/notification-reply" component={NotificationReply} />
            <PrivateRoute path="/compose-new-message" component={NotificationCompose} />
            <PrivateRoute path="/compose-new-message-admin" component={NotificationComposeSingle} />
            <PrivateRoute path="/account-care-coord" component={CareCoordinatorAccount} />
            <PrivateRoute path="/direct-admit-request" component={DirectAdmitRequest} />
        
            
        </Switch>
    </Router>
);